import { useRouter } from 'next/router';
import cn from 'classnames';
import { Button } from '@fabric-ds/react';

import styles from './TopBarMap.module.css';

type TopBarMapProps = {
    toggleFilterState: () => void;
    filtersOpen: boolean;
    numResults: number;
};

export const TopBarMap = ({ toggleFilterState, filtersOpen, numResults }: TopBarMapProps) => {
    const router = useRouter();
    const searchParams = new URLSearchParams(router.query as Record<string, string>);

    return (
        <div className={cn(styles.topbarMap, 'flex flex-row items-center justify-between map-top-bar ph-8')}>
            <Button small href={`${router.basePath}/resultat/?${searchParams.toString()}`} data-testid="closeMapButton">
                Lukk kart
            </Button>
            <output data-testid="resultCount">
                <span className="font-bold">{numResults}</span> treff
            </output>
            <Button small onClick={toggleFilterState} data-testid="showFilterButton">
                {filtersOpen ? 'Lukk filter' : 'Vis filter'}
            </Button>
        </div>
    );
};
